// extracted by mini-css-extract-plugin
export default {"tooltip":"LineChartTooltip_tooltip__G4fZu"};